export enum UserProfileType {
	Facebook,
    FacebookWebchat,
    Google,
    Apple,
    GoogleAssistant,
    SMS,
    Preload,
}
